import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { MaintenanceOrderActivitiesModel } from 'src/app/models/maintenance/maintenance-order-activities.model';
import { MaintenanceOrderActivitiesTableModel } from 'src/app/models/tables/maintenance/maintenance-order-activities-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceOrderActivitiesService {

  constructor(private _httpClient: HttpClient) { }

  createActivitiesByMaintenancePlanAsync(maintenanceOrderId: number, articleId: number, maintenancePlan: number): Observable<boolean> {
    const params = new HttpParams()
      .set('maintenanceOrderId', maintenanceOrderId)
      .set('articleId', articleId)
      .set('maintenancePlan', maintenancePlan);
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderActivities.CreateActivitiesByMaintenancePlanAsync}`, null, { params: params });
  }

  deleteAllMaintenanceOrderActivitiesAsync(maintenanceOrderId: number): Observable<boolean> {
    return this._httpClient.delete<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderActivities.DeleteAllMaintenanceOrderActivitiesAsync}/${maintenanceOrderId}`);
  }

  getMaintenanceOrderActivities(maintenanceOrderId: number): Observable<MaintenanceOrderActivitiesTableModel[]> {
    return this._httpClient.get<MaintenanceOrderActivitiesTableModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderActivities.GetMaintenanceOrderActivitiesAsync}/${maintenanceOrderId}`);
  }

  getTotalMaintenanceOrderActivitiesAsync(maintenanceOrderId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderActivities.GetTotalMaintenanceOrderActivitiesAsync}/${maintenanceOrderId}`);
  }

  updateMaintenanceOrderActivities(maintenanceOrderActivitiesId: number, swExecuted: boolean, swRescheduled: boolean): Observable<MaintenanceOrderActivitiesModel> {
    const params = new HttpParams()
      .set('maintenanceOrderActivitiesId', maintenanceOrderActivitiesId)
      .set('swExecuted', swExecuted)
      .set('swRescheduled', swRescheduled);
    return this._httpClient.post<MaintenanceOrderActivitiesModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderActivities.UpdateAsync}`, null, { params: params });
  }


}
